import { render, staticRenderFns } from "./ViolationToggler.vue?vue&type=template&id=2352a4d6&"
import script from "./ViolationToggler.vue?vue&type=script&lang=ts&"
export * from "./ViolationToggler.vue?vue&type=script&lang=ts&"
import style0 from "./ViolationToggler.vue?vue&type=style&index=0&id=2352a4d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports